import { Link } from 'react-router-dom';

function HomePage() {
  return (
    <div>
      <section className="relative min-h-[78vh] overflow-hidden">
        <img
          src="/assets/images/home/banner_1920x1024.webp"
          alt="Equipo directivo de Krystal Software"
          className="absolute inset-0 h-full w-full object-cover object-left-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#020812]/95 via-[#020812]/78 to-[#020812]/35" />

        <div className="relative mx-auto flex min-h-[78vh] max-w-7xl items-center px-4 py-20 md:px-8">
          <div className="max-w-3xl">
            <span className="mb-5 inline-block rounded-full border border-white/30 bg-black/30 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.18em] text-[#9ED4FF]">
              Consultoría de software y arquitectura
            </span>
            <h1 className="text-4xl font-extrabold leading-tight tracking-tight text-white md:text-6xl">
              Construimos infraestructura digital con precisión estratégica.
            </h1>
            <p className="mt-6 max-w-2xl text-lg text-white/85">
              Diseñamos y modernizamos plataformas de alto impacto para empresas que necesitan
              escalar con seguridad, velocidad y visión de negocio.
            </p>
            <div className="mt-10 flex flex-wrap gap-4">
              <Link
                to="/contacto"
                className="rounded-lg bg-primary px-7 py-4 text-sm font-bold text-white shadow-lg shadow-black/30 transition-all hover:-translate-y-0.5 hover:brightness-110"
              >
                Iniciar proyecto
              </Link>
              <Link
                to="/servicios"
                className="rounded-lg border border-white/30 bg-white/10 px-7 py-4 text-sm font-bold text-white backdrop-blur-sm transition-all hover:bg-white/20"
              >
                Ver capacidades
              </Link>
            </div>
          </div>
        </div>

      </section>

      <section className="bg-surfaceContainerLow py-16">
        <div className="mx-auto grid max-w-7xl grid-cols-2 gap-8 px-4 md:grid-cols-4 md:px-8">
          <div>
            <p className="text-[11px] font-bold uppercase tracking-widest text-onSurfaceVariant">Proyectos</p>
            <p className="mt-2 text-4xl font-extrabold text-onSurface">150+</p>
          </div>
          <div>
            <p className="text-[11px] font-bold uppercase tracking-widest text-onSurfaceVariant">Ingenieros</p>
            <p className="mt-2 text-4xl font-extrabold text-onSurface">15</p>
          </div>
          <div>
            <p className="text-[11px] font-bold uppercase tracking-widest text-onSurfaceVariant">Retención</p>
            <p className="mt-2 text-4xl font-extrabold text-onSurface">98%</p>
          </div>
          <div>
            <p className="text-[11px] font-bold uppercase tracking-widest text-onSurfaceVariant">Años</p>
            <p className="mt-2 text-4xl font-extrabold text-onSurface">12</p>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-24 md:px-8">
        <div className="mb-14 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <h2 className="text-3xl font-extrabold tracking-tight md:text-4xl">
              Expertise de ingeniería aplicada a resultados reales.
            </h2>
            <p className="mt-4 text-onSurfaceVariant">
              Combinamos arquitectura cloud, ciberseguridad, IA aplicada y desarrollo a medida
              para construir plataformas resilientes.
            </p>
          </div>
          <Link to="/servicios" className="font-bold text-primary">
            Ver todos los servicios →
          </Link>
        </div>

        <div className="grid gap-6 md:grid-cols-3">
          <article className="rounded-2xl border border-outlineVariant/30 bg-white p-8 md:col-span-2">
            <span className="material-symbols-outlined text-primary">architecture</span>
            <h3 className="mt-4 text-2xl font-bold">Arquitectura Cloud Native</h3>
            <p className="mt-3 text-onSurfaceVariant">
              Diseñamos sistemas distribuidos preparados para escalar, con alta disponibilidad y
              observabilidad en tiempo real.
            </p>
            <img
              src="https://lh3.googleusercontent.com/aida-public/AB6AXuBGQpUKxdU6f8dn0AXLsr7JkdMKNSfNllaAXMvc2CkyKmthAoWL4r45rAGE4EC9MmxjIXUg2Nxp58T5IzjEYmnnYLObMJJGhCGeYlq26vdvPTZFs0HIHTbwL0TkO1TYa-Nm78gQPdhiSbllPBeTQZxjaONvbldQJoiwikDdrjQvvfw5naQVvwz4O60iJ1uCVUwsTGsUiwje7VpA6bIcPXAtkrazs-vQJB41vsyWZChrAEpeeLfXR0wvEFWMDro9PbbQtrDYt6gmhGSO"
              alt="Infraestructura digital"
              className="mt-6 h-44 w-full rounded-xl object-cover"
            />
          </article>

          <article className="rounded-2xl bg-surfaceContainer p-8">
            <span className="material-symbols-outlined text-primary">security</span>
            <h3 className="mt-4 text-2xl font-bold">Ingeniería de Seguridad</h3>
            <p className="mt-3 text-onSurfaceVariant">
              Integración de seguridad desde el diseño: cifrado, hardening y cumplimiento para
              operaciones críticas.
            </p>
          </article>

          <article className="rounded-2xl bg-primary p-8 text-white">
            <span className="material-symbols-outlined">robot_2</span>
            <h3 className="mt-4 text-2xl font-bold">IA Aplicada</h3>
            <p className="mt-3 text-white/80">
              Implementamos automatización inteligente y analítica avanzada para aumentar
              productividad y calidad de decisión.
            </p>
          </article>

          <article className="rounded-2xl bg-surfaceContainerLow p-8 md:col-span-2 md:grid md:grid-cols-2 md:items-center md:gap-8">
            <div>
              <span className="material-symbols-outlined text-primary">terminal</span>
              <h3 className="mt-4 text-2xl font-bold">Software Empresarial a Medida</h3>
              <p className="mt-3 text-onSurfaceVariant">
                Soluciones personalizadas para procesos complejos, integraciones legacy y nuevas
                líneas de negocio digital.
              </p>
            </div>
            <img
              src="https://lh3.googleusercontent.com/aida-public/AB6AXuAPZZZ6lyVFc6DHmbxLuJ1NHzJd3y9MFWEcPLF_D4ZtSp3i9jQICGsNPwkU9EWzttRcl6chg4gwcrBfmhegqThVpOd5O1_C5ukmOT6KJcIIyQDJQjqBrbrxQpE810D1bDEa071m3toRcJRv5WrbDhO2syXIusg4jwjRn9a-wVQ1xbziUdPSqnhpGR6rHFFRd8hurUS0yhCzWuu1y7uyIBFXFdqWX7oBI33ScG7JZ9M762P0ViCpElZI2sy9r9yaArR4VhvbRPx1oN8Z"
              alt="Monitores con código"
              className="mt-6 h-44 w-full rounded-xl object-cover md:mt-0"
            />
          </article>
        </div>
      </section>

      <section className="bg-white py-24">
        <div className="mx-auto max-w-4xl px-4 text-center md:px-8">
          <span className="material-symbols-outlined text-6xl text-primary/20">format_quote</span>
          <p className="mt-6 text-2xl italic leading-relaxed text-onSurface md:text-4xl">
            "Krystal no solo entrega software: entrega claridad, estructura y aceleración de
            negocio."
          </p>
          <p className="mt-6 text-sm font-semibold text-onSurfaceVariant">
            {"< -- >"}
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 pb-24 md:px-8">
        <div className="rounded-2xl bg-inverseSurface p-10 text-inverseOnSurface md:p-16">
          <h2 className="text-3xl font-extrabold md:text-5xl">Listos para definir su próxima evolución.</h2>
          <p className="mt-4 max-w-2xl text-inverseOnSurface/70">
            Conversemos sobre su objetivo tecnológico y diseñemos una ruta clara de implementación.
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <Link to="/contacto" className="rounded-md bg-primary px-7 py-3 font-bold text-white">
              Contactar consultoría
            </Link>
            <Link to="/acerca" className="rounded-md border border-white/20 px-7 py-3 font-bold">
              Conocer Krystal
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default HomePage;
